module.exports = __webpack_public_path__ + "static/white_dragon-6ed974d0729cd68516d6a1195efa8479.jpg";